'use client'

import { useState } from 'react'

export const MIN_KEYWORD_LENGTH = 2

export enum TabType {
  ALL = 'all',
  REGION = 'region',
  SUBWAY = 'subway',
  LANDMARK = 'landmark',
}

export const useTab = () => {
  const [tab, setTab] = useState<TabType>(TabType.ALL)

  const handleTabChange = (value: string) => {
    if (value) {
      setTab(value as TabType)
    }
  }

  return { tab, handleTabChange }
}
